// Simplified analytics stub - removed detailed tracking
class AnalyticsManager {
  constructor() {
    this.isInitialized = false;
  }

  // Initialize analytics
  init(measurementId) {
    if (typeof window === 'undefined') return;
    
    this.isInitialized = true;
    console.log('Analytics initialized');
  }

  // Basic tracking methods that do nothing
  trackPageView() {}
  trackEvent() {}
  trackServiceInteraction() {}
  trackAppointmentScheduling() {}
  trackContactSubmission() {}
  trackResourceDownload() {}
  trackExternalLink() {}
  trackScrollDepth() {}
  trackTimeOnPage() {}
  calculateEngagementScore() { return 0; }
  trackFunnelStep() {}
  trackServiceInterest() {}
  trackLeadQuality() {}
  setUserProperty() {}
  trackDemographics() {}
}

// Create singleton instance
const analytics = new AnalyticsManager();

export default analytics;